import { useContext } from 'react'
import {
  SurveyModalContext,
  SurveyModalContextType,
} from '@context/SurveyModalContext/index'

const useSurveyModal = (): SurveyModalContextType =>
  useContext(SurveyModalContext)

export default useSurveyModal
